import { render, staticRenderFns } from "./AuxiliaryMachineDetails.vue?vue&type=template&id=c8b48298&"
import script from "./AuxiliaryMachineDetails.vue?vue&type=script&lang=js&"
export * from "./AuxiliaryMachineDetails.vue?vue&type=script&lang=js&"
import style0 from "./AuxiliaryMachineDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports